
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
const firebaseConfig = {
  apiKey: "AIzaSyAzRwr49ThAwZMD_xM-4FnjF5ShE3fc6aM",
  authDomain: "talent-junction-app.firebaseapp.com",
  projectId: "talent-junction-app",
  storageBucket: "talent-junction-app.firebasestorage.app",
  messagingSenderId: "32540309898",
  appId: "1:32540309898:web:7c08ceb0a5a76de0b6f073",
  measurementId: "G-SNQHGPZBN5"
};
 
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export { app, analytics };